var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGuideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 5.8335H7.08334M10.4158 9.16683H7.08252",
    stroke: "#626262",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6668 18.3332H5.00016C4.07969 18.3332 3.3335 17.587 3.3335 16.6665M3.3335 16.6665C3.3335 15.746 4.07969 14.9998 5.00016 14.9998H16.6668V4.99984C16.6668 3.42849 16.6668 2.64281 16.1787 2.15466C15.6905 1.6665 14.9048 1.6665 13.3335 1.6665H8.3335C5.97647 1.6665 4.79796 1.6665 4.06573 2.39874C3.3335 3.13097 3.3335 4.30948 3.3335 6.6665V16.6665Z",
    stroke: "#626262",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2498 15C16.2498 15 15.4165 15.6357 15.4165 16.6667C15.4165 17.6977 16.2498 18.3333 16.2498 18.3333",
    stroke: "#626262",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGuideIcon);
export default __webpack_public_path__ + "static/media/user-guide-icon.5eee4fc9434741b2d49245387812f649.svg";
export { ForwardRef as ReactComponent };